document.addEventListener('DOMContentLoaded', () => {
  // Threshold in cents. Prefer an explicit global set from theme.liquid or Rebuy SmartCart config.
  let threshold = Number(window?.Rebuy?.SmartCart?.progressBar?.tiers?.[0]?.minimum);
  let subtotal = Number(event?.detail?.smartcart?.cart?.total_price);
  let remaining = Math.max(0, Number(threshold * 100) - (Number(subtotal) || 0));
  let isSubscriptionProduct =
    window?.Rebuy?.SmartCart?.cart?.items[0]?.selling_plan_allocation?.selling_plan?.name?.includes('subscription');

  const handleCartUpdate = () => {
    threshold = Number(
      window?.Rebuy?.SmartCart?.progressBar?.tiers?.[0]?.minimum ??
        document.querySelector('.cart-delivery')?.dataset.threshold,
    );
    subtotal = Number(
      window?.Rebuy?.Cart?.cart?.total_price ?? document.querySelector('.cart-delivery')?.dataset.subtotal,
    );
    remaining = Math.max(0, Number(threshold * 100) - (Number(subtotal) || 0));
    isSubscriptionProduct =
      window?.Rebuy?.SmartCart?.cart?.items[0]?.selling_plan_allocation?.selling_plan?.name?.includes('subscription') ??
      Boolean(document.querySelector('.rebuy-cart__flyout-item-add-x')?.dataset.subscriptionProduct);
    const flyout = document.querySelector('.rebuy-cart__flyout');
    if (!flyout) return;

    flyout.classList.toggle('threshold-reached', remaining <= 0);
    flyout.classList.toggle('subscription', isSubscriptionProduct);
    flyout.classList.toggle('onetime', !isSubscriptionProduct);
  };

  const handleAddXButton = () => {
    const checkoutButton = document.querySelector('.rebuy-cart__checkout-button');
    const lineItems = document.querySelectorAll('.rebuy-cart__flyout-item-add-x');
    if (!lineItems.length) return;
    document.querySelector('.rebuy-cart__flyout')?.classList.toggle('threshold-reached', remaining <= 0);
    if (remaining <= 0) {
      if (checkoutButton) {
        checkoutButton.disabled = false;
      }
      lineItems.forEach((item) => {
        const button = item.querySelector('.rebuy-add-x-more');
        const itemTiers = JSON.parse(
          document.querySelector(`.cart-tier-price[data-variant-id="${item.dataset.variantId}"]`).dataset.tiers,
        );
        if (!JSON.parse(itemTiers).length) {
          button.classList.add('hidden');
          return;
        }
        const currentQuantity = window?.Rebuy?.SmartCart?.cart?.items[0].quantity || item.dataset.qty;
        const next = JSON.parse(itemTiers).find((t) => t.qty > currentQuantity);
        if (typeof next === 'undefined') {
          button.classList.add('hidden');
          return;
        }
        const quantityRequired = (next.qty - currentQuantity).toString();
        item.setAttribute('data-quantity', quantityRequired);
        button.innerHTML = (
          Number(quantityRequired) === 1
            ? window.tier_price_1_html
            : window.tier_price_x_html.replace('{{ count }}', quantityRequired)
        ).replace('{{ price }}', next.save);
        button.classList.remove('hidden');
      });
      return;
    }

    if (checkoutButton) {
      checkoutButton.disabled = Boolean(isSubscriptionProduct);
    }

    lineItems.forEach((item) => {
      const button = item.querySelector('.rebuy-add-x-more');
      const currentPrice = parseInt(item.getAttribute('data-unit-price-cents') || '0', 10);
      let quantityRequired = Math.ceil(remaining / currentPrice).toString();
      const tierElement = document.querySelector(`.cart-tier-price[data-variant-id="${item.dataset.variantId}"]`)
        ?.dataset.tiers;
      const itemTiers = tierElement ? JSON.parse(tierElement) : '';
      if (itemTiers && JSON.parse(itemTiers).length) {
        const currentQuantity = window?.Rebuy?.SmartCart?.cart?.items[0].quantity || Number(item.dataset.qty);
        const next = JSON.parse(itemTiers).find((t) => t.qty < currentQuantity + Number(quantityRequired));
        if (typeof next !== 'undefined' && currentQuantity + Number(quantityRequired) > next.qty) {
          quantityRequired = (
            Math.ceil(
              Math.min(remaining + currentQuantity * currentPrice, Number(threshold * 100)) /
                parseInt(next.price || '0', 10),
            ) - currentQuantity
          ).toString();
        }
      }

      item.setAttribute('data-quantity', quantityRequired);
      if (isSubscriptionProduct) {
        button.textContent =
          quantityRequired === '1'
            ? window.add_1_more_subscription
            : window.add_x_more_subscription.replace('{{count}}', quantityRequired);
      } else {
        button.textContent =
          quantityRequired === '1' ? window.add_1_more : window.add_x_more.replace('{{count}}', quantityRequired);
      }
      button.classList.remove('hidden');
    });
  };

  const waitForCartSync = async (dom, { timeout = 5000, interval = 100 } = {}) => {
    const start = Date.now();
    while (Date.now() - start < timeout) {
      const currentDom = document.querySelectorAll('.rebuy-add-x-more');
      if (dom !== currentDom && Date.now() - start > 500) return currentDom;
      await new Promise((r) => setTimeout(r, interval));
    }
    return dom;
  };

  const handleAddXEventListeners = async () => {
    const elements = await waitForCartSync(document.querySelectorAll('.rebuy-add-x-more'));
    elements.forEach((button) => {
      button.removeEventListener('click', handleAddXClick);
      button.addEventListener('click', handleAddXClick);
    });
  };

  const handleAddXClick = (event) => {
    const button = event.currentTarget;
    const wrap = button.closest('.rebuy-cart__flyout-item-add-x');
    const variantId = Number(wrap.getAttribute('data-variant-id'));
    const item = window?.Rebuy?.SmartCart?.cart?.items.find((item) => item.variant_id === variantId);
    const sellingPlanId =
      item?.selling_plan_allocation?.selling_plan?.id ??
      button.closest('.rebuy-cart__flyout-item-add-x')?.dataset?.subscriptionId;
    const properties =
      item?.properties ??
      Object.fromEntries(
        JSON.parse(button.closest('.rebuy-cart__flyout-item-add-x')?.dataset?.properties?.replaceAll('&', '"')),
      );
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: parseInt(wrap.getAttribute('data-quantity') || '0', 10),
            properties: properties ?? '',
            selling_plan: isSubscriptionProduct ? sellingPlanId : '',
          },
        ],
      }),
    })
      .then(function () {
        if (document.body.classList.contains('cart-template')) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rebuy' });
        } else {
          window.Rebuy.SmartCart.reload();
        }

        button.classList.add('hidden');
        button.textContent = window.add_x_more;
        button.disabled = false;
      })
      .catch(function () {
        button.disabled = false;
      });
  };

  const handleSavings = () => {
    if (!isSubscriptionProduct || !document.querySelector('.rebuy-cart__flyout-savings-amount .amount')) return;

    let totalVariantPrice = 0;
    window?.Rebuy?.SmartCart?.cart?.items.forEach((item) => {
      const itemPrice = item.product.selected_variant.compare_at_price;
      totalVariantPrice += (typeof itemPrice === 'string' ? Number(itemPrice) * 100 : itemPrice) * item.quantity;
    });
    const savings = totalVariantPrice - window?.Rebuy?.SmartCart?.cart?.total_price;
    document.querySelector('.rebuy-cart__flyout-savings-amount .amount').textContent =
      window?.Rebuy?.SmartCart?.formatMoney(savings);
  };

  const handleDeliverySelector = () => {
    const deliverySelector = document.querySelector('.rebuy-cart__flyout #delivery-frequency');
    if (!deliverySelector) return;
    deliverySelector.value =
      document.querySelector('.rebuy-cart__flyout-item-subscription .rebuy-select')?.value?.match(/\d+/)?.[0] || '4';

    const deliveryChange = (e) => {
      const weekSelected = String(e.target.value).trim();

      document.querySelectorAll('.rebuy-cart__flyout-item-subscription .rebuy-select').forEach((select) => {
        const target = Array.from(select.options).find((opt) => opt.value.match(/\d+/)?.[0] === weekSelected);
        if (target && target.value && select.value.match(/\d+/)?.[0] !== weekSelected) {
          select.value = target.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    };

    deliverySelector.removeEventListener('change', deliveryChange);
    deliverySelector.addEventListener('change', deliveryChange);
  };

  const handleOptionChange = (e) => {
    if (e && !e?.target?.classList.contains('option-input')) return;
    const selectedSubscription =
      String(
        e?.target?.value ?? document.querySelector('.subscription-card .option-input:checked')?.value ?? '4',
      ).match(/\d+/)?.[0] || '4';

    let totalSubscriptionPrice = 0;
    window?.Rebuy?.SmartCart?.cart?.items.forEach((item) => {
      const subscriptionId = item?.product?.selected_variant?.selling_plans?.find(
        (plan) => plan.name.match(/\d+/)?.[0] === selectedSubscription,
      )?.id;
      const subscriptionPrice = item?.product?.selected_variant?.selling_plan_allocations?.find(
        (plan) => plan.selling_plan_id === subscriptionId,
      )?.price;
      totalSubscriptionPrice +=
        (typeof subscriptionPrice === 'string' ? Number(subscriptionPrice) * 100 : subscriptionPrice) * item.quantity;
    });

    const savings = window?.Rebuy?.SmartCart?.cart?.total_price - totalSubscriptionPrice;
    document.querySelector('.subscription-card .amount').textContent = window?.Rebuy?.SmartCart?.formatMoney(savings);
  };

  const subscriptionSwitch = () => {
    const selectedSubscription =
      String(document.querySelector('.subscription-card .option-input:checked')?.value ?? '4').match(/\d+/)?.[0] || '4';
    const buttonLabel = document.querySelector('.subscription-card .button span');
    const buttonSpinner = document.querySelector('.subscription-card .button .loading__spinner');

    buttonLabel.classList.add('hidden');
    buttonSpinner.classList.remove('hidden');

    window?.Rebuy?.SmartCart?.cart?.items.forEach((item) => {
      const subscriptionName = item?.product?.selected_variant?.selling_plans?.find(
        (plan) => plan.name.match(/\d+/)?.[0] === selectedSubscription,
      )?.name;
      if (subscriptionName) {
        window?.Rebuy?.SmartCart?.updateItemDeliveryFrequency(item, subscriptionName, 'onetime');
      }
    });

    buttonSpinner.classList.add('hidden');
    buttonLabel.classList.remove('hidden');
  };

  const handleSubscriptionSwitcher = () => {
    const subscriptionSwitcherButton = document.querySelector('.subscription-card .button');
    if (!subscriptionSwitcherButton) return;

    handleOptionChange();

    document.querySelectorAll('.subscription-card .options > label').forEach((label) => {
      label.removeEventListener('click', handleOptionChange);
      label.addEventListener('click', handleOptionChange);
    });

    subscriptionSwitcherButton.removeEventListener('click', subscriptionSwitch);
    subscriptionSwitcherButton.addEventListener('click', subscriptionSwitch);
  };

  document.addEventListener('rebuy:smartcart.ready', (event) => {
    handleAddXEventListeners();
  });

  // When Rebuy cart becomes ready
  document.addEventListener('rebuy:smartcart.show', (event) => {
    handleCartUpdate();
    handleAddXButton();
    handleSavings();
    handleDeliverySelector();
    handleSubscriptionSwitcher();
  });

  // On any cart change triggered by Rebuy
  document.addEventListener('rebuy:cart.change', (event) => {
    handleCartUpdate();
    handleAddXButton();
    handleSavings();
    handleAddXEventListeners();
  });
});
